import React from 'react';

export const PropertyTaxes = () => {
  return <div className="w-ful h-[400px]"></div>;
};
